import React from 'react';
import httpClient from '../../httpClient'
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import LoginForm from './LoginForm'
import SignupForm from './SignupForm'
import LoginProForm from './LoginProForm';
import HebergReserv from '../common/Hebergement/hebergReserv';
import PayMethForm from '../common/paimentPopUps/payMethForm';
import ContactPayModal from '../common/paimentPopUps/contactPayModal';
import ViaPayModal from '../common/paimentPopUps/viaPayModal';
import BaridiModal from '../common/paimentPopUps/baridiModal';
import NewMessage from '../Admin/newMsgModal';


class LoginModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalLogin: false,
      modalReserve : false,
      modalSignup: this.props.count,
      modalPRO: false,
      fields: {email: '', password: ''}

    };

    this.toggle = this.toggle.bind(this);
    this.toggleSignup = this.toggleSignup.bind(this);
    this.togglePRO = this.togglePRO.bind(this);


  }


  toggle() {
    this.setState({
      modalLogin: true,
      modalReserve :true
    });
  }
  toggleSignup() {
    this.setState({
      modalLogin:false,
      modalSignup: !this.state.modalSignup
    });
  }
  togglePRO() {
    this.setState({
      modalLogin:false,
      modalSignup: false,
      modalPRO:!this.state.modalPRO
    });
  }

  // Login process


	onInputChange(evt) {
		this.setState({
			fields: {
				...this.state.fields,
				[evt.target.name]: evt.target.value
			}
		})
	}

	onFormSubmitLogin(evt) {
		evt.preventDefault()
		httpClient.logIn(this.state.fields).then(user => {
			this.setState({ fields: { email: '', password: '' } })
			if(user) {
        this.props.onLoginSuccess(user)
        this.setState({
          modalLogin: false,
          
          modalSignup:false
        });
			}
		})
	}

	onFormSubmitSignup(evt) {
		evt.preventDefault()
		httpClient.signUp(this.state.fields).then(user => {
			this.setState({ fields: { name: '', email: '', password: '' } })
			if(user) {
				this.props.onSignUpSuccess(user)
        this.setState({
          modalLogin: false,
       
          modalSignup:false
        });			}
		})
	}

	onFormSubmitPRO(evt) {
		evt.preventDefault()
		httpClient.logIn(this.state.fields).then(user => {
      this.setState({ fields: { email: '', password: '' } })
      if(user.B2b){
        this.props.onLoginSuccess(user)
      this.props.history.push(`/agent`);
      }
			if(user) {
        this.props.onLoginSuccess(user)
        this.setState({
          modalLogin: false,
        
          modalSignup:false,
          modalPRO:false
        });
			}
		})
	}
  ////////////
  toogleClose = () =>{
    this
    .props
    .dispatch({type: "CLOSING_MODAL"})
}

openSignUpForm = () =>{
  this
  .props
  .dispatch({type: "SIGNUP_FORM"})
}
openSignUpProForm = () =>{
  this
  .props
  .dispatch({type: "SIGNUP_PRO_FORM"})
}



  render() {
    return (
      <div>

        {/* <Button  className="loginButton" onClick={this.toggle} >{this.props.buttonLabel} Login</Button> */}
        <LoginForm onLoginSuccess={this.props.onLoginSuccess.bind(this)}/>
        <SignupForm onSignUpSuccess = {this.props.onSignUpSuccess.bind(this)} />
        <LoginProForm onLoginSuccess={this.props.onLoginSuccess.bind(this)}/>
        <PayMethForm />
        <HebergReserv />
        <ContactPayModal />
        <ViaPayModal />
        <BaridiModal />
        <NewMessage />

        </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    login: state.modal.login,
    reserve: state.modal.reserve,
    signUp:state.modal.signup,
    pro:state.modal.signupPro
  }
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(LoginModal));